import React from "react";
import Header from "../../components/HeaderNew";
import {Button} from "@material-ui/core";
import Footer from "../FooterNew";
import {Helmet} from "react-helmet";

function Cex() {
  return (
    <div className="newpage">
      <header>
        <Header />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                Cryptocurrency Derivatives Exchange Development Company |
                Decentralize Derivatives Exchange
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/crypto-derivatives-exchange-development"
              />
              <meta
                name="title"
                content="Cryptocurrency Derivatives Exchange Development Company | Decentralize Derivatives Exchange
                "
              />

              <meta
                name="description"
                content="We develop custom cryptocurrency derivative exchange platforms for your business needs. Get a feature-rich derivatives exchange for your business by leveraging our DEX derivatives exchange development services."
              />
              <meta
                name="keywords"
                content="derivatives exchange development services,Decentralize derivative exchange development company, crypto derivatives platform, trading software company,Derivative Exchange Development
                    "
              />
            </Helmet>
            <div className="ourserveic_banner">
              <div className="bg-overlay"></div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-10">
                    <div className="service_content">
                      <h1> Crypto Derivatives Exchange development </h1>
                      <p>
                        Beleaf Technologies Has vast expertise in developing and
                        managing crypto exchange products and platforms.
                      </p>
                      <Button data-toggle="modal" data-target="#myModal">
                        Get A Quote Now
                      </Button>
                      {/* <div className="pt-4 pb-0 mt-1 banner_text_section">
                            <Button>Demo</Button>
                          </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text-center">
                        start your crypto journey with our superlative crypto
                        exchange software
                      </h2>
                      <p className="text-center">
                        With our Crypto Derivatives Exchange Development, you
                        can get the benefits of derivatives trading without the
                        hassle. We build risk-based platforms that make it easy
                        for investors to get the best possible returns, and our
                        user-friendly interface makes it easy to understand how
                        derivative trading works.
                        <br />
                        The platform is built with a flexible API that makes it
                        easy for you to integrate with your existing
                        infrastructure. Our API can be used for virtually any
                        purpose, from tracking your investments to trading
                        against other traders in our marketplace
                        <br />
                        Our team has extensive knowledge in the financial
                        industry and has worked on development projects for
                        world-renowned institutions such as Goldman Sachs,
                        JPMorgan Chase, Citibank, and other top investment banks
                        around the world. We have also worked on projects that
                        were used by the US Department of Defense.
                      </p>
                      <Button data-toggle="modal" data-target="#myModal">
                        Get A Quote Now
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      <Footer />
    </div>
  );
}

export default Cex;
